module.exports = __webpack_public_path__ + "media/images/top/dress-image-b9a979cc8d2a17affad42c3e2d0b343c.png";